import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
/* eslint-disable import/named */
import { MultiValue } from 'react-select';
import { toast, ToastContainer } from 'react-toastify';
import { Form } from 'react-bootstrap';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import MultiSelectSortable, {
  ReactSelectOption,
} from '../Selects/SortableSelect';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { GetHarmfulFactorDtoCategoryEnum } from '../../../common/spdCore/autogenerated/spdApiClient';
import FormRow from '../../../app/components/FormRow';
import { HarmfulFactorCategoryText } from '../../../common/spdCore/validation/schemas';

export interface HarmfulFactorMultiSelectorProps {
  readOnly?: boolean;
  selectedHarmfulFactor?: string[];
  onChange?: (options: MultiValue<ReactSelectOption>) => void;
}

export default (props: HarmfulFactorMultiSelectorProps) => {
  const spd = useSpdCore();
  const [harmfulFactories, setHarmfulFactories] = useState<
    ReactSelectOption[][]
  >([]);
  const [selectedHarmfulFactories, setSelectedHarmfulFactories] = useState<
    ReactSelectOption[][]
  >([]);
  const [ready, setReady] = useState(false);

  const handleCategoryChange = (
    index: number,
    options: MultiValue<ReactSelectOption>,
  ) => {
    if (!props.onChange) {
      return;
    }

    const updatedFactories = [...selectedHarmfulFactories];
    updatedFactories[index] = options as ReactSelectOption[];

    const allSelectedOptions = updatedFactories.flat().filter(item => item);

    setSelectedHarmfulFactories(updatedFactories);
    props.onChange(allSelectedOptions);
  };

  useEffect(() => {
    let mounted = true;
    spd.harmfulFactors
      .getAll()
      .then(t => {
        if (mounted) {
          const result = t.sort((a, b) =>
            (a.name + (a.description || '')).localeCompare(
              b.name + (b.description || ''),
            ),
          );

          const harmTab = Object.values(GetHarmfulFactorDtoCategoryEnum).map(
            category =>
              result
                .filter(a => a.category === category)
                .map(
                  a =>
                    ({
                      value: a.id,
                      label:
                        a.name + (a.description ? ` (${a.description})` : ''),
                    }) as ReactSelectOption,
                ),
          );

          setHarmfulFactories(harmTab);

          if (
            props.selectedHarmfulFactor &&
            props.selectedHarmfulFactor.length > 0
          ) {
            const selectedFactories = Object.values(
              GetHarmfulFactorDtoCategoryEnum,
            ).map(category => {
              return result
                .filter(
                  a =>
                    a.category === category &&
                    props.selectedHarmfulFactor?.includes(a.id),
                )
                .map(
                  a =>
                    ({
                      value: a.id,
                      label:
                        a.name + (a.description ? ` (${a.description})` : ''),
                    }) as ReactSelectOption,
                );
            });
            setSelectedHarmfulFactories(selectedFactories);
          }

          setReady(true);
        }
      })
      .catch(async error => {
        const err = await responseErrors(error);
        toast.error(
          `Wystąpił problem z pobraniem czynników szkodliwych. Spróbuj się wylogować i zalogować ponownie.  ${err}`,
          {
            toastId: 'harmful-factor-toast-id',
          },
        );
      });

    return () => {
      mounted = false;
    };
  }, [spd.harmfulFactors, props.selectedHarmfulFactor]);

  return (
    <>
      <ToastContainer />
      {ready ? (
        <Form className="d-grid gap-3">
          {harmfulFactories.map((category, index) => (
            <FormRow
              controlId={'harmfulFactories' + index}
              label={
                'Czynniki szkodliwe - ' +
                Object.values(HarmfulFactorCategoryText)[index]
              }
              key={index}
            >
              <MultiSelectSortable
                key={index}
                options={category}
                defaultValue={selectedHarmfulFactories[index] || []}
                onChange={options => handleCategoryChange(index, options)}
              />
            </FormRow>
          ))}
        </Form>
      ) : (
        <Skeleton />
      )}
    </>
  );
};
